import { render } from "./UploadSignature.vue?vue&type=template&id=27dbf26e"
import script from "./UploadSignature.vue?vue&type=script&lang=js"
export * from "./UploadSignature.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__